import axios from "axios";

export default {
    namespaced: true,

    state: {
        services: null,
        categoriesServices: null,
    },

    mutations: {
        getServicesSuccess(state, data) {
            state.services = data?.services;
            state.categoriesServices = data?.categories;
        },
    },

    actions: {
        getAppointment({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/schedule/appointments/${id}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getConfirmData({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/schedule/get-confirm-data", { params })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getServices({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/schedule/get-services", { params })
                    .then((res) => {
                        commit("getServicesSuccess", res.data?.data);
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getLocations({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/schedule/active-locations", { params })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getEmployees({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/schedule/active-employees", { params })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getCustomerProfile({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/schedule/customer-profile/${id}`)
                    .then((res) => {
                        resolve(res.data.data.customer);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getAvailableSlots({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/schedule/available-slots", { params })
                    .then((res) => {
                        resolve(res.data.data.datas);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        save({ commit }, scheduleData) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/customers/schedule", scheduleData, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        cancelOrder({ commit }, cancelData) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/schedule/${cancelData.id}/cancel-order`, cancelData)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },

    getters: {
        services: (state) => state.services,
        categoriesServices: (state) => state.categoriesServices,
    },
};
